export default ".conceito {\n  color: red;\n}\n\n.alert a {\n  color: #004085 !important;\n  text-decoration: underline;\n}\n"